
export const AUX_ROUTE = '/sessionStream';


const QR_OVERRIDE_ORIGIN = '';

const extractToken = (qrUrl, sessionId) => {
  if (sessionId) return sessionId;
  try {
    const u = new URL(qrUrl);
    return u.searchParams.get('token') || '';
  } catch {
    return '';
  }
};

export const buildQrTarget = (qrUrl, sessionId) => {
  if (!QR_OVERRIDE_ORIGIN) return qrUrl || '';
  const token = extractToken(qrUrl, sessionId);
  return `${QR_OVERRIDE_ORIGIN}${AUX_ROUTE}?token=${encodeURIComponent(token)}`;
};